import React from "react";
import { PortableText } from "../../lib/sanity/plugins/portabletext";
import { urlForImage } from "../../lib/sanity/image";
import { blogHref } from "../../lib/paths";
//import { Link } from "react-router-dom";

export default function AuthorCard({ author }) {
  const imageProps = author?.image ? urlForImage(author.image) : null;
  return (
    <div className="mt-3 rounded-2xl bg-gray-50 px-8 py-8 text-gray-500 dark:bg-gray-900 dark:text-gray-400">
      <div className="flex flex-wrap items-start sm:flex-nowrap sm:space-x-6">
        <div className="relative mt-1 h-24 w-24 flex-shrink-0 ">
          {imageProps && (
            <a href={blogHref(`/author/${author.slug.current}`)}>
              <img
                src={imageProps.src}
                alt={author.name}
                className="rounded-full object-cover"
                fill="true"
                sizes="96px"
              />
            </a>
          )}
        </div>
        <div>
          <div className="mb-3">
            <h3 className="text-lg font-medium text-gray-800 dark:text-gray-300">
              About {author.name}
            </h3>
          </div>
          <div>
            {author.bio && <PortableText blocks={author.bio} />}
            
          </div>
        </div>
      </div>
    </div>
  );
}

/*
<div className="mt-3">
<a
  href={blogHref(`/author/${author.slug.current}`)}
  href="https://www.linkedin.com/in/rohullah-karimi-86b11214b/"
  className="bg-brand-secondary/20 rounded-full py-2 text-sm text-blue-600 dark:text-blue-500 ">
  Näytä profiili
</a>
</div>
*/